var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27290_97768)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1C11.8656 1 14.9999 4.13445 15 8C15 11.8656 11.8656 15 8 15C4.13438 15 1 11.8656 1 8C1.00009 4.13445 4.13443 1 8 1ZM8 10C7.80374 10.004 7.61688 10.0854 7.47949 10.2256C7.34228 10.3657 7.26567 10.5539 7.26562 10.75C7.26562 10.9463 7.34211 11.1352 7.47949 11.2754C7.61686 11.4155 7.80379 11.496 8 11.5C8.1962 11.496 8.38314 11.4155 8.52051 11.2754C8.65789 11.1352 8.73438 10.9463 8.73438 10.75C8.73433 10.5539 8.65772 10.3657 8.52051 10.2256C8.38312 10.0854 8.19626 10.004 8 10ZM7.625 4.5C7.55631 4.5 7.50009 4.55633 7.5 4.625V8.875C7.5 8.94375 7.55625 9 7.625 9H8.375C8.44375 9 8.5 8.94375 8.5 8.875V4.625C8.49991 4.55633 8.44369 4.5 8.375 4.5H7.625Z",
    fill: "#FAAD14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27290_97768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnIcon);
export default __webpack_public_path__ + "static/media/warn-icon.93a06463d86974664bd8d147bb2c2d91.svg";
export { ForwardRef as ReactComponent };